import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DBService {
  //Uses Firestore as the NoSQL database. There is no reason to use the old Firebase realtime
  //DB, since Firestore does everything that one does and also supports proper queries.
  constructor(public afs: AngularFirestore) {
                console.log('data-service is loaded and available to be called');
              }

    // Returns an observable against a collection with optional query
    // like afs.collection.valueChanges, but includes the ID of each document
    // this makes subsequent update / deletes much easier. See query docs below.

    /*
    Creating a query with primitive/scalar values
    Queries are created by building on the firebase.firestore.Reference.

    afs.collection('items', ref => ref.where('size', '==', 'large'))
    Query Options:

    method	purpose
    where	Create a new query. Can be chained to form complex queries.
    orderBy	Sort by the specified field, in descending or ascending order.
    limit	Sets the maximum number of items to return.
    startAt	Results start at the provided document (inclusive).
    startAfter	Results start after the provided document (exclusive).
    endAt	Results end at the provided document (inclusive).
    endBefore	Results end before the provided document (exclusive). */


  public getCollection(path, includeIds: boolean, queryFn?) {
    let collection = this.afs.collection(path, queryFn);
    if (!includeIds) 
        return collection.valueChanges();

    let observable = collection.snapshotChanges().map(arr => {
        return arr.map(snap => {
               const data = snap.payload.doc.data();
               const id = snap.payload.doc.id;
               return { id, ...data };
        });
      });

      return observable;
  }

  // convenience method... handles update-and-replace / upsert and 
  // non-destructive update. returns an angularfire2 promise
  public update(path: string, data: any, isDestructive: boolean) {
    const doc = this.afs.doc<any>(path);
    if (isDestructive)
        return doc.set(data); // reset all properties with new data
    else
        return doc.update(data); // only update the fields specified in data, leave the others
  }
  // if you are making your own ids (as you should), this is a nice little 
  // insert / update: upsert("Users/SamRahimi", {pic: "1.jpg", name: "Sam Rahimi"})
  public upsert(path, data) {
      return this.update(path, data, true);
  }

  // Gets a single document. Returns either a docRef or the .valueChanges observable
  public getDoc(path: string, returnObservable: boolean) {
    let itemDoc = this.afs.doc<any>(path);
    if (!returnObservable) {
        return itemDoc;
    }
    return itemDoc.valueChanges();
  }
}



// WEBPACK FOOTER //
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/core/services/db.service.ts